import * as React from "react";

import { Limits } from "Utility/Limits";

import { ZeroQuiltSize } from "Model/IQuiltSize";
import { IGeneralQuiltParams } from "Model/IGeneralQuiltParams";

import { SizeField } from "Components/SizeField";

export interface IProps {
    readonly params: IGeneralQuiltParams;

    readonly onChanged: (params: IGeneralQuiltParams) => void;
}

export function GeneralEditor(props: IProps): React.ReactElement {
    const generalParams = props.params;
    
    const onSizeChanged = (w: number, h: number) => {
        props.onChanged({
            ...generalParams,
            rows: w,
            columns: h
        });
    };

    const onPaddingChanged = (w: number, h: number) => {
        props.onChanged({
            ...generalParams,
            padding: {
                width: w,
                height: h
            }
        });
    };

    const padding = generalParams.padding ?? ZeroQuiltSize;

    return (
        <form>
            <SizeField
                widthStr={"Rows"}
                heightStr={"Columns"}

                width={generalParams.rows}
                height={generalParams.columns}

                widthMin={1}
                widthMax={Limits.MaxRowCol}

                heightMin={1}
                heightMax={Limits.MaxRowCol}

                onChanged={onSizeChanged}

                isInteger />

            <SizeField
                widthStr={"Pad width (in)"}
                heightStr={"Pad height (in)"}

                width={padding.width}
                height={padding.height}

                widthMin={0}
                widthMax={Limits.MaxPadding}

                heightMin={0}
                heightMax={Limits.MaxPadding}

                onChanged={onPaddingChanged} />
        </form>
    );
}